// extracted by mini-css-extract-plugin
module.exports = {"article":"styles_article__Vexpl"};